module.exports = __webpack_public_path__ + "img/9021cb5f9681ab9339f84c5cf8aad8d9.png";